import { Form, Input, Col, Row, Card, Radio, Button, Space } from 'antd'
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons'
import StoreSelectBase from '../../../components/BaseInfoSelects/StoreSelectBase'
import TimeDurationFormItem from '../../../components/TimeDurationFormItem'
import AuthComponent from '../../../components/AuthComponent'
import {transfersOutStatusMap, transfersInStatusMap} from '../config'
import {useEffect} from "react";
import StoreSelectAll from "../../../components/BaseInfoSelects/StoreSelectAll";
const basicDurationKeys = ['beginCreateTime', 'endCreateTime']
const initialValues = {
  status: ''
}
export default function ProductTransfersListBasicForm({getList, children = '', stockType, no=null}) {
  const [form] = Form.useForm()
  form.setFieldsValue({no: no})
  const getDefaultStoreCodeAndRequst = res => {
    form.setFieldsValue({ destStoreCode: res.storeCode })
    baseGetListByFormData()
  }
  const getDefaultStoreCodeAndRequstt = res => {
    form.setFieldsValue({ sourceStoreCode: res.storeCode })
    baseGetListByFormData()
  }
  const baseGetListByFormData = () => {
    if (stockType == 'out'){
      if (form.getFieldValue('sourceStoreCode')) {
        let formData = form.getFieldsValue()
        delete formData.duration
        getList({ formData: formData })
      }
    }else if (stockType == 'in'){
      if (form.getFieldValue('destStoreCode')) {
        let formData = form.getFieldsValue()
        delete formData.duration
        getList({ formData: formData })
      }
    }
  }
  useEffect(() => {
    form.resetFields()
    if (stockType == 'in'){
      form.setFieldsValue({ sourceStoreCode: null })
    }
    baseGetListByFormData()
  }, [stockType])
  return (
    <Card>
      <Form
        wrapperCol={{ style: { marginBottom: 20 } }}
        layout='inline'
        labelCol={{ style: { width: 90, textAlign: 'right' } }}
        form={form}
        initialValues={initialValues}>
        {stockType == 'in'?
          <>
            <Form.Item name='destStoreCode' label='所属门店' required>
              <StoreSelectBase
                style={{ width: 180 }}
                OnOptionsLoad={getDefaultStoreCodeAndRequst}
              />
            </Form.Item>
            <Form.Item name='sourceStoreCode' label='调出门店'>
              <StoreSelectAll style={{ width: '160px' }} />
            </Form.Item>
          </>
         : <Form.Item name='sourceStoreCode' label='所属门店' required>
            <StoreSelectBase
              style={{ width: 180 }}
              OnOptionsLoad={getDefaultStoreCodeAndRequstt}
            />
          </Form.Item>}
        <Form.Item name='no' label='调拨单号'>
          <Input placeholder='请输入' style={{ width: 180 }} />
        </Form.Item>
        <Form.Item
          name='status'
          label='调拨单状态'
          style={{ textAlign: 'left' }}>
          {
            stockType == 'out'? <Radio.Group>
              <Radio value={''}>全部</Radio>
              {Object.keys(transfersOutStatusMap).map(item => (
                <Radio key={item} value={item}>
                  {transfersOutStatusMap[item]}
                </Radio>
              ))}
            </Radio.Group>:
              <Radio.Group>
                <Radio value={''}>全部</Radio>
                {Object.keys(transfersInStatusMap).map(item => (
                  <Radio key={item} value={item}>
                    {transfersInStatusMap[item]}
                  </Radio>
                ))}
              </Radio.Group>
          }

        </Form.Item>
        <Form.Item name='handlerName' label='经手人'>
          <Input placeholder='请输入' style={{ width: 180 }} />
        </Form.Item>
        <TimeDurationFormItem
          keys={basicDurationKeys}
          label='创建时间'
          form={form}
        />
      </Form>
      <Space>
        <AuthComponent authKey='/inventory/check-sheet/list'>
          <Button
            type='primary'
            ghost
            onClick={baseGetListByFormData}
            icon={<SearchOutlined />}>
            查询
          </Button>
        </AuthComponent>
        <Button
          type='primary'
          ghost
          icon={<ReloadOutlined />}
          onClick={() => form.resetFields()}>
          重置
        </Button>
        {children}
      </Space>
    </Card>
  )
}
